import React, { useState } from "react";

interface TableColumnsProps {
    size?: number | string;
    className?: string;
    onClick?: () => void;
    color?: string
}

const TableColumns: React.FC<TableColumnsProps> = ({
    size = 20,
    className,
    onClick,
    color
}) => {
    const [isHovered, setIsHovered] = useState<boolean>(false);
    const style = size ? { width: size, height: size } : undefined;

    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            className={className}
            style={style}
            onClick={onClick}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <path
                d='M10 6.5V17.5M10 17.5H13.5C14.9001 17.5 15.6002 17.5 16.135 17.2275C16.6054 16.9878 16.9878 16.6054 17.2275 16.135C17.5 15.6002 17.5 14.9001 17.5 13.5V11.6667V6.5C17.5 5.09987 17.5 4.3998 17.2275 3.86502C16.9878 3.39462 16.6054 3.01217 16.135 2.77248C15.6002 2.5 14.9001 2.5 13.5 2.5H6.5C5.09987 2.5 4.3998 2.5 3.86502 2.77248C3.39462 3.01217 3.01217 3.39462 2.77248 3.86502C2.5 4.3998 2.5 5.09987 2.5 6.5V11.6667V13.5C2.5 14.9001 2.5 15.6002 2.77248 16.135C3.01217 16.6054 3.39462 16.9878 3.86502 17.2275C4.3998 17.5 5.09987 17.5 6.5 17.5H10Z'
                stroke={isHovered ? "#0094BD" : color}
                strokeWidth='1.67'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M2.5 3.75L5 2.91667L10 2.5L15 2.91667L17.5 3.75V7.5H2.5V3.75Z'
                fill={isHovered ? "#0094BD" : color}
            />
        </svg>
    );
};

export default TableColumns;
